import React from 'react';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '../icons/trashW.svg';

const DeletePopup = ({ open, onCancel, extra = false, onConfirm, loading = false }) => {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[1050]">
      <div className="w-[614px] h-[376px] bg-[#F9FAFC] shadow-[0px_20px_80px_#00000011] rounded-[12px] p-6">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-28 h-28 bg-[#EF476F] rounded-full flex items-center justify-center">
            <img src={DeleteIcon} alt="Delete Icon" className="w-10 h-10" />
          </div>
        </div>
        {/* Text */}
        <div className="text-center py-4 px-16 text-[#36495C] font-medium text-[20px]" style={{ fontFamily: "Montserrat" }}>
          {t(`placeholder.deleteConfirmation`)}
        </div>
        {/* Extra */}
        {extra && (
          <div className="text-center  text-[#EF476F] font-bold text-[12px]" style={{ fontFamily: "Montserrat" }}>
            {t(`placeholder.configWarning`)}
          </div>
        )}
        {/* Buttons */}
        <div className="flex justify-center gap-12 mt-6">
          <button
            onClick={onCancel}
            className="rounded-[12px] px-14 py-2 text-[#4A4A4A] bg-white hover:bg-gray-100 border border-gray-300"
            style={{ fontFamily: "Montserrat", fontWeight: 500 }}
          >
            {t(`placeholder.no`)}
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="rounded-[12px] px-14 py-2 bg-[#EF476F] text-white hover:bg-[#d63d5d] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            style={{ fontFamily: "Montserrat", fontWeight: 500 }}
          >
            {loading ? (
              <>
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                <span>{t(`actions.deleting`) || 'Suppression...'}</span>
              </>
            ) : (
              t(`placeholder.yes`)
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePopup;
